import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/root/workspace/com.jufair.pc.nuxt3_46wE/layouts/default.vue"))
}